export default __webpack_public_path__ + "static/media/chevron-down-circle.428bad5f.svg";